/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_IndexnowInputs */

const en_admin_nav_indexnow = /** @type {(inputs: Admin_Nav_IndexnowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IndexNow`)
};

/**
* | output |
* | --- |
* | "IndexNow" |
*
* @param {Admin_Nav_IndexnowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_indexnow = /** @type {((inputs?: Admin_Nav_IndexnowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_IndexnowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_indexnow(inputs)
});
export { admin_nav_indexnow as "admin.nav.indexnow" }